<template>
	<div class="comment-wrapper">
		<div class="comment">
			<div class="title">
				<span class="icon"></span>软件点评
				<span class="tip">共{{total}}条</span>
				<el-button type="warning" size="mini" class="commit" @click="dialogVisible = true">点评</el-button>
			</div>
			<div>
				<div class="comment-item" v-for="item in dataList">
					<div class="user" v-if="item.postUserInfo">
						<el-image :src="item.postUserInfo.avatar" fit="fill"></el-image>
						<span class="name">{{item.postUserInfo.nickname}}</span>
						<span class="createDate">{{item.createDate}}</span>
					</div>
					<div class="message">{{item.bodyText}}</div>
					<div class="rate-wrapper">
						<el-rate v-model="item.score" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate>
						<span class="like" @click="rateup(item.id)"><i class="iconfont icon-good"></i>{{item.likedCount==0?'点赞':item.likedCount}}</span>
					</div>
				</div>
				<div class="nomore">没有更多喽~</div>
			</div>
		</div>
		
		<el-dialog title="" :visible.sync="dialogVisible" width="335px">
		  <div class="title"><i class="iconfont icon-weixin"></i>微信扫码点评</div>
		  <div class="tips">打开微信，扫描下方二维码，写点评</div>
		  <div class="image">
			  <el-image class="comment-image" :src="require('@/assets/qrcode.jpg')" fit="fill"></el-image>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
import { getCommentlist } from '@/api/software/index'
export default {
  props:['data'],
  data () {
    return {
	  dialogVisible: false,
      dataList: [],
	  total: 0
    }
  },
  methods: {
	async getDataList(){
		const res = await getCommentlist({page:1,limit:10,themeId:this.data.id})
		if (res.code === 0) {
			this.dataList = res.data.list
			this.total = res.data.total
		} else {
		  this.$message.error(res.msg)
		}
	},
	async rateup(id){
		
	},
	async collect(){
		const res = await softCollect({dataId:this.data.id,type:'1'})
		if (res.code === 0) {
			this.$message.success('收藏成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
  },
  mounted () {
	window.scrollTo({top:0})
	this.data.id = this.$route.params.softwareId
	this.getDataList()
  }

}
</script>

<style lang="scss" scoped>
.comment-wrapper{
	.comment{
		background-color: #fff;
		border-radius: 8px;
		padding: 30px;
		padding-left: 35px;
		box-sizing: border-box;
		.title{
			font-size: 20px;
			font-weight: 800;
			color: #000000;
			margin-bottom: 10px;
			border-bottom: 1px solid #D9D8D9;
			padding-bottom: 10px;
			position: relative;
			.icon{
				position: absolute;
				top: 5px;
				left: -15px;
				display: inline-block;
				width: 6px;
				height: 20px;
				background-color: #FF8632;
				border-top-right-radius: 6px;
				border-bottom-right-radius: 6px;
			}
			.tip{
				font-weight: 500;
				color: #979799;
				font-size: 15px;
				margin-left: 10px;
			}
		}
		.commit{
			float: right;
			background-color: #FF8632;
		}
		.comment-item{
			padding:10px 0;
			margin-top: 10px;
			border-bottom: 1px solid #D9D8D9;
		}
		.user{
			.el-image{
				width: 30px;
				height: 30px;
				border-radius: 50%;
			}
			.name{
				color:#404450;
				font-size: 15px;
				display: inline-block;
				vertical-align: top;
				margin-left: 8px;
				margin-top: 5px;
			}
			.createDate{
				color: #A1A7B0;
				font-size: 14px;
				float: right;
				margin-top: 5px;
			}
		}
		.message,.rate-wrapper{
			padding-left: 38px;
		}
		.rate-wrapper{
			.el-rate{
				display: inline-block;
			}
			.like{
				color: #A1A7B0;
				font-size: 14px;
				margin-left: 28px;
				cursor: pointer;
			}
		}
		.nomore{
			color: #A1A7B0;
			font-size: 14px;
			margin: 30px 0 10px;
			text-align: center;
		}
		
		
	}
	/deep/.el-dialog__body{
		.title{
			font-size: 22px;
			font-weight: 800;
			text-align: center;
			color: #000000;
			.iconfont{
				color: #32ae1c;
				font-size: 28px;
				margin-right: 10px;
			}
		}
		.tips{
			color: #404450;
			text-align: center;
			font-size: 16px;
			margin-top: 10px;
		}
		.image{
			text-align: center;
			margin-top: 10px;
		}
		.comment-image{
			width: 220px;
			height: 220px;
			margin: 20px auto;
		}
	}
}

</style>